<template>
  <div class="Comment">
    <div class="pages">
      <div class="card-head">
        <div class="left">
          <img :src="res.img" alt />
        </div>
        <div class="right flex-1">
          <p class="text">{{res.title}}</p>
          <div class="right-bottom">
            <span>
              总价：
              <span class="orange">￥{{res.price|priceFilter}}</span>
            </span>
          </div>
        </div>
      </div>
      <div class="in-title">
        <i></i>
        <span>订单信息</span>
      </div>
      <ul class="orders">
        <li>
          <span class="label">数量:</span>
          <span class="text">{{res.userCardList?res.userCardList.length:0}}</span>
        </li>
        <li>
          <span class="label">下单时间:</span>
          <span class="text">{{res.gmtCreate}}</span>
        </li>
        <li>
          <span class="label">订单编号:</span>
          <span class="text">{{res.orderNo}}</span>
        </li>
      </ul>
    </div>
    <!-- 交易信息 -->
    <div class="card pages">
      <div class="in-title">
        <i></i>
        <span>交易信息</span>
      </div>
      <ul class="orders">
        <li>
          <span class="label">交易时间:</span>
          <span class="text">{{res.payTime}}</span>
        </li>
        <li>
          <span class="label">交易编号:</span>
          <span class="text">{{res.transactionId}}</span>
        </li>
        <li>
          <span class="label">支付方式:</span>
          <span class="text">微信支付</span>
        </li>
      </ul>
    </div>
    <!-- 使用信息 -->
    <div class="card pages last-page">
      <div class="in-title">
        <i></i>
        <span>使用信息</span>
      </div>
      <ul class="orders">
        <li>
          <span class="label">使用时间:</span>
          <span class="text">{{res.userCardList[0].verifyTime}}</span>
        </li>
        <li>
          <span class="label">使用编号:</span>
          <span class="text">{{res.userCardList[0].appointmentShopName}}</span>
        </li>
      </ul>
      <!-- <van-button
        type="primary"
        class="large-button"
        @click="getSubmit"
        :disabled="res.status===4"
      >{{res.status===4?'已评价':'评价'}}</van-button>-->
      <van-button type="primary" class="large-button" @click="getSubmit" v-if="res.status===3">评价</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Comment",
  components: {},
  data () {
    return {
      query: {},
      res: {}
    };
  },
  computed: {},
  mounted () {
    this.query = this.getQuery(this);
    if (this.query.id) {
      this.getDetail();
    }
  },
  methods: {
    // 退款
    handleRebate () {
      this.go("/refund");
    },
    // 评价
    getSubmit () {
      this.query = this.getQuery(this);
      this.go("/assess?id=" + this.query.id);
    },
    // user/userOrder/get
    async getDetail () {
      let res = await this.request("/user/userOrder/get", {
        id: this.query.id
      });
      if (res.code === 0) {
        // console.log(res);
        this.res = { ...res.data };
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/css/style";
.Comment {
  background: #f7f7f7;
  height: 100vh;
  overflow: auto;
  .pages {
    background: #fff;
    padding: @pad;
    margin-bottom: @pad;
    &.last-page {
      margin-bottom: 0;
    }
  }
  .grey {
    color: #585858;
  }
  .orange {
    color: #ff8939;
  }
  .ellis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 90%;
  }
  .title {
    font-size: 15px;
    font-weight: bold;
    color: #333;
  }
  .in-title {
    .flex-center();
    justify-content: flex-start;
    i {
      display: inline-block;
      width: 3px;
      height: 12px;
      background: #3296fa;
      margin-right: 5px;
    }
    span {
      font-size: 15px;
      font-weight: bold;
      color: #333;
    }
  }
  .card-head {
    .flex-center();
    margin-bottom: @pad;
    .left {
      width: 65px;
      margin-right: @pad;
      img {
        width: 100%;
        border-radius: 3px;
      }
    }
    .right {
      .text {
        font-size: 14px;
      }
      .right-bottom {
        .flex-center();
        justify-content: space-between;
        font-size: 13px;
      }
      .van-button {
        padding: 0;
        height: 28px;
        line-height: 28px;
        width: 55px;
        color: #585858;
      }
    }
  }
  .large-button {
    width: 80%;
    display: block;
    margin: 50px auto 15px auto;
  }
  .orders {
    margin-top: 10px;
    li {
      .label {
        width: 80px;
        display: inline-block;
      }
      line-height: 35px;
      .sc(14px, #979797);
    }
  }
}
</style>